import { WARM_DASHBOARD_API_BASE } from "./apiEndpoints";

export function GetCTACard() {
  return fetch(`${WARM_DASHBOARD_API_BASE}/getCTACard`);
}

export function GetBillingPlan(email) {
  const options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
    },
    body: JSON.stringify({ email }),
  };

  return fetch(`${WARM_DASHBOARD_API_BASE}/getBillingPlan`, options);
}

export function GetPricingPlan() {
  return fetch(`${WARM_DASHBOARD_API_BASE}/getPricingPlan`);
}

export function SubmitCancelReason({ reason, note }) {
  const options = {
    method: "POST",
    body: JSON.stringify({
      timestamp: new Date().toISOString(),
      reason,
      note,
    }),
  };

  return fetch(
    "https://hooks.zapier.com/hooks/catch/8876124/2wk6la3/",
    options
  );
}

export const GetPaymentHistory = (email) => {
  const options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
    },
    body: JSON.stringify({
      email,
    }),
  };

  return fetch(
    `${WARM_DASHBOARD_API_BASE}/getPaymentHistory?filter_by=current`,
    options
  );
};

export const StripeAPI = (body) => {
  const options = {
    method: "POST",
    body: JSON.stringify(body),
  };

  return fetch(`${WARM_DASHBOARD_API_BASE}/stripeAPI`, options);
};

const BillingAPI = {
  GetCTACard,
  GetBillingPlan,
  GetPricingPlan,
  SubmitCancelReason,
};

export default BillingAPI;
